import { RouteEntry } from "../../shared/routes";
import { IdentityRoles } from "../../configure/security/IdentityRoles";
import { SchoolNavigation } from "./SchoolNavigation";

export const schoolSidebarRoutes: Array<RouteEntry> = [
    { path: '/school', component: SchoolNavigation, authorize: true, requireRole: IdentityRoles.SchoolUser },
];
